import { createApp } from 'vue'
import { useToastStore } from './store'
import Toast from './toast.vue'

declare module '@vue/runtime-core' {
  interface ComponentCustomProperties {
    $toast: ReturnType<typeof useToastStore>
  }
}

export * from './store'

const installWrapper = () => {
  if (document.querySelector('#toast-wrapper')) {
    return
  }

  const $el = document.createElement('div')
  const app = createApp(Toast)
  $el.id = 'toast-wrapper'
  $el.classList.add('tw')
  document.body.appendChild($el)
  app.mount($el)
}

export const toastPlugin = {
  install (app) {
    if (typeof app.config.globalProperties.$toast !== 'undefined') {
      console.log('[toast] plugin already installed, skipping')
      return
    }
    const store = useToastStore()
    app.config.globalProperties.$toast = store
    installWrapper()
    // console.log('[toast] plugin installed')
  }
}

